export const selectProducts = (state) => state.products.list;
export const selectProductsFetched = (state) => state.products.fetched;
export const selectProduct = (state, id) => state.products.list[id] || null;
export const selectProductAttributes = (state, id) => state.products.attributes[id] || {};

export const selectCategory = (state, id) => state.products.categories[id] || null;
